// 🔹 Flexibility Behavioural Scenario Bank

export const FLEXIBILITY_BANK = [

  {
    id: "flx_01",

    dimension: "flexibility",

    behaviour: "adaptability",

    scenario: "changed_schedule",

    text: "Your teacher suddenly changes the plan for today's lesson. You usually...",

    options: [
      {
        label: "Adjust quickly and continue working",
        weights: { flexibility: +2 }
      },
      {
        label: "Need a little time to adjust before continuing",
        weights: { flexibility: +1 }
      },
      {
        label: "Feel uncomfortable but continue anyway",
        weights: { flexibility: -1 }
      },
      {
        label: "Wish things had stayed the way they were planned",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_02",

    dimension: "flexibility",

    behaviour: "working_style",

    scenario: "assignment_change",

    text: "You've already started an assignment when your teacher changes the instructions. You usually...",

    options: [
      {
        label: "Adjust your work to fit the new instructions",
        weights: { flexibility: +2 }
      },
      {
        label: "Change only the parts that are necessary",
        weights: { flexibility: +1, control: +1 }
      },
      {
        label: "Prefer sticking to your original plan",
        weights: { flexibility: -1 }
      },
      {
        label: "Feel frustrated and struggle to continue",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_03",

    dimension: "flexibility",

    behaviour: "creativity",

    scenario: "different_solution",

    text: "A class activity isn't working as expected. You usually...",

    options: [
      {
        label: "Suggest a completely different way of doing it",
        weights: { flexibility: +2 }
      },
      {
        label: "Build on someone else's idea",
        weights: { flexibility: +1, thinking: +1 }
      },
      {
        label: "Keep using the original idea",
        weights: { flexibility: 0 }
      },
      {
        label: "Wait for someone else to solve it",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_04",

    dimension: "flexibility",

    behaviour: "learning_agility",

    scenario: "new_subject",

    text: "You begin learning a subject you've never studied before. You usually...",

    options: [
      {
        label: "Enjoy learning something completely new",
        weights: { flexibility: +2 }
      },
      {
        label: "Take your time and learn it step by step",
        weights: { flexibility: +1 }
      },
      {
        label: "Only learn what's necessary",
        weights: { flexibility: 0 }
      },
      {
        label: "Feel discouraged if it seems difficult",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_05",

    dimension: "flexibility",

    behaviour: "ambiguity",

    scenario: "open_assignment",

    text: "Your teacher gives an assignment but leaves you free to decide how to complete it. You usually...",

    options: [
      {
        label: "Enjoy choosing your own approach",
        weights: { flexibility: +2 }
      },
      {
        label: "Think of a plan before getting started",
        weights: { flexibility: +1, thinking: +1 }
      },
      {
        label: "Wish there were more detailed instructions",
        weights: { flexibility: -1 }
      },
      {
        label: "Feel uncomfortable without clear guidance",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_06",

    dimension: "flexibility",

    behaviour: "openness",

    scenario: "different_opinion",

    text: "A friend shares an opinion that's very different from yours. You usually...",

    options: [
      {
        label: "Try to understand their point of view",
        weights: { flexibility: +2, affection: +1 }
      },
      {
        label: "Listen before deciding whether you agree",
        weights: { flexibility: +1, thinking: +1 }
      },
      {
        label: "Prefer sticking with your own opinion",
        weights: { flexibility: -1 }
      },
      {
        label: "Dismiss the idea immediately",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_07",

    dimension: "flexibility",

    behaviour: "experimentation",

    scenario: "study_method",

    text: "Your usual way of studying isn't helping you understand a topic. You usually...",

    options: [
      {
        label: "Try completely different study methods",
        weights: { flexibility: +2 }
      },
      {
        label: "Make small changes to your usual method",
        weights: { flexibility: +1 }
      },
      {
        label: "Keep studying the same way for a while longer",
        weights: { flexibility: -1 }
      },
      {
        label: "Assume you're just not good at the topic",
        weights: { flexibility: -2 }
      }
    ]
  },

  {
    id: "flx_08",

    dimension: "flexibility",

    behaviour: "resilience",

    scenario: "poor_test_result",

    text: "You receive a test score that's much lower than you expected. You usually...",

    options: [
      {
        label: "Change your approach and prepare differently next time",
        weights: { flexibility: +2 }
      },
      {
        label: "Think about what went wrong before trying again",
        weights: { flexibility: +1, thinking: +1 }
      },
      {
        label: "Take some time before deciding what to do next",
        weights: { flexibility: 0 }
      },
      {
        label: "Feel discouraged and lose motivation to try again",
        weights: { flexibility: -2 }
      }
    ]
  },

];